import React from "react";
import { motion } from "framer-motion";
import { springVariants, opacityVariants, springViewport } from '../utils/framerVariants';

const LinkList = ({ data }) => {
  return (
    <div className="mb-16 md:mb-24 lg:mb-32 xl:mb-48">
      <div className="linkList">
        {data.Links.map((link, index) => (
          <motion.div
            variants={opacityVariants}
            initial="invisible"
            whileInView="visible"
            viewport={springViewport}
            className={`relative z-[18] link-entry border-b-4 border-black transition-colors duration-200 bg-white hover:bg-yellow ${index === 0 ? "border-t-4" : ""}`}
            key={`link__${link.id}`}
          >
            {link.LinkURL && (
              <div className="container mx-auto max-w-none px-4 md:px-8">
                <a href={link.LinkURL} target={`_${link.LinkTargets}`} className="flex h-full items-center">
                  <h2 className="font-bold grow pt-8 pb-5 sm:pt-10 sm:pb-9 xl:pt-10 xl:pb-10 text-headline-md tracking-headline-md sm:text-headline sm:tracking-headline leading-[1] relative top-[-7px]">
                    {link.Title}
                  </h2>
                  <svg className="flex-none w-3 sm:w-4 md:w-6 lg:w-8" viewBox="0 0 27 48" xmlns="http://www.w3.org/2000/svg">
                    <g stroke="#000" strokeWidth="4" fill="none" fillRule="evenodd" strokeLinecap="square">
                      <path d="m3.026 3.024 21 20.918M3.026 44.977l20.913-21.005" />
                    </g>
                  </svg>
                </a>
              </div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default LinkList;
